// @flow
import React, { Component } from 'react';

import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';

import { grey100 } from 'material-ui/styles/colors';

import ClosableDialog from 'components/ClosableDialog';
import GeometryFormatSelectField from 'components/GeometryFormatSelectField';
import FormatHelpCard from './FormatHelpCard';

import FeatureToggle from 'components/FeatureToggle';

const styles = {
  textField: {
    background: grey100,
    borderRadius: 2,
    padding: 6,
  },

  invalidMessage: {
    color: 'red',
  },

  coords: {
    fontFamily: 'monospace',
    background: '#F0F0F0',
    padding: 2,
    borderRadius: 3,
  },
};

export default class CoordinateInputDialog extends Component {
  state = {
    value: '',
  };

  render() {
    return (
      <ClosableDialog
        title="Koordináták megadása"
        actions={[
          <FlatButton
            label="Rendben"
            primary
            onClick={() => this.props.submitCoordinateList(this.state.value)}
          />,
        ]}
        open={this.props.visible}
        onRequestClose={() => this.props.toggleCoordinateInputDialog(false)}
        autoScrollBodyContent
      >
        <FeatureToggle flag="hasSubscription">
          <GeometryFormatSelectField
            geometryFormat={this.props.geometryFormat}
            setGeometryFormat={this.props.setGeometryFormat}
          />
        </FeatureToggle>

        <FormatHelpCard geometryFormat={this.props.geometryFormat} />

        {this.props.invalid ? (
          <p style={styles.invalidMessage}>
            A megadott koordináták szintaktikailag hibásak!
          </p>
        ) : (
          ''
        )}

        <TextField
          floatingLabelText="Koordináták listája"
          rows={6}
          textareaStyle={styles.textField}
          multiLine
          fullWidth
          onChange={(_, value) => this.setState({ value })}
        />
      </ClosableDialog>
    );
  }
}



// WEBPACK FOOTER //
// ./components/CoordinateInputDialog/CoordinateInputDialog.js